import { BottomSheet, type UseModalState } from "@clipboard-health/ui-components";
import { DialogContent, Stack } from "@mui/material";
import { isCapacitorPlatform } from "@src/appV2/lib";

import { BottomSheetHeader } from "../../components/BottomSheetHeader";
import { Button } from "../../components/Button";
import { DialogFooter } from "../../components/DialogFooter";

interface BadgePhotoSelectionBottomSheetProps {
  modalState: UseModalState;
  hasProfilePicture: boolean;
  onTakePhoto: () => Promise<void>;
  onSelectFromCameraRoll: () => Promise<void>;
  onUseProfilePicture: () => void;
}

export function BadgePhotoSelectionBottomSheet(props: BadgePhotoSelectionBottomSheetProps) {
  const {
    modalState,
    hasProfilePicture,
    onTakePhoto,
    onSelectFromCameraRoll,
    onUseProfilePicture,
  } = props;

  return (
    <BottomSheet
      footer={<DialogFooter orientation="vertical" />}
      header={<BottomSheetHeader onClose={modalState.closeModal} />}
      modalState={modalState}
    >
      <DialogContent sx={{ padding: 5, paddingBottom: 0 }}>
        <Stack spacing={3}>
          {isCapacitorPlatform() && (
            <Button variant="outlined" size="large" onClick={onTakePhoto}>
              Take a photo
            </Button>
          )}
          <Button variant="outlined" size="large" onClick={onSelectFromCameraRoll}>
            Upload from camera roll
          </Button>
          {hasProfilePicture && (
            <Button variant="outlined" size="large" onClick={onUseProfilePicture}>
              Use profile picture
            </Button>
          )}
        </Stack>
      </DialogContent>
    </BottomSheet>
  );
}
